import { useState, useCallback, useEffect } from "react";
import { Section, SectionData, Image as ImageType } from "shared/types";
import { ReactComponent as Logo } from "assets/images/logo-magog.svg";
import { Link } from "react-router-dom";
import Image from "shared/images";
import { sectionData } from "data/sections";

type HeaderProps = {
  section: Section;
  menuOpen: boolean;
  toggleMenu: () => void;
  navigateSection: (section: Section) => void;
};

export const Header = (props: HeaderProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const [currentSection, setCurrentSection] = useState<SectionData | null>(
    null
  );

  const SCROLL = {
    scrollTop: 0,
    delta: 0,
  };

  const handleScroll = useCallback(() => {
    SCROLL.delta = window.scrollY > SCROLL.scrollTop ? -1 : 1;
    SCROLL.scrollTop = window.scrollY;
    if (SCROLL.scrollTop > 80) {
      setIsScrolled(true);
      SCROLL.delta > 0 ? setIsVisible(true) : setIsVisible(false);
    } else {
      setIsScrolled(false);
      setIsVisible(false);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    if (!props.section || props.section === "MAGOG") {
      setCurrentSection(null);
    }

    const current = sectionData.find(el => el.section === props.section);
    if (current) {
      setCurrentSection(current as SectionData);
    }
  }, [props.section]);

  return (
    <div
      className={`Header ${isVisible ? "visible" : ""} ${
        isScrolled ? "scrolled" : ""
      }  ${props.menuOpen ? "menuOpen" : ""} `}
    >
      <Link to="/" onClick={() => props.navigateSection("MAGOG")}>
        <div className="brand">
          <Logo />
        </div>
      </Link>
      <div className="menu-toggle" onClick={() => props.toggleMenu()}>
        <div className={`hamburger ${props.menuOpen ? "open" : ""}`}>
          <div className="line bread-top"></div>
          <div className="line bread-bottom"></div>
          <div className="dish"></div>
        </div>
      </div>
      <div className="brand-current">
        {currentSection && (
          <Image
            name={currentSection.logo as ImageType}
            title={currentSection.title}
          />
        )}
      </div>
    </div>
  );
};
